import React from 'react'
import { Field } from '@ztechapps/webui.form'
import { TextAreaInput } from '@ztechapps/webui.input'
import { TooltipPopOver } from '@ztechapps/webui.util'
import { Stack } from 'react-bootstrap'

export const ProjectAddFormInput = () => {
  return (
    <Stack gap={3}>
      <div>
        <Field label="Name" title="Name of the project" name="name" />
      </div>
      <TooltipPopOver tooltipBody="Summary or overview of the project.">
        <div>
          <Field label="Summary" name="summary" component={TextAreaInput} />
        </div>
      </TooltipPopOver>
    </Stack>
  )
}
